import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useApp } from '../context/AppContext';

const Footer = () => {
  const { t } = useApp();
  const cols = [
    { title: t.footer.product, items: [t.nav.chat, t.nav.agents, t.nav.build, t.nav.pricing] },
    { title: t.footer.company, items: ['About', 'Blog', 'Careers', 'Contact'] },
    { title: t.footer.legal, items: ['Privacy', 'Terms', 'Security', 'Cookies'] }
  ];
  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <span className="h-9 w-9 rounded-xl bg-primary flex items-center justify-center">
                <Sparkles className="h-5 w-5 text-primary-foreground" />
              </span>
              <span className="font-display text-xl font-bold">Aurra<span className="text-primary">.</span></span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">{t.footer.tagline}</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display font-semibold text-sm mb-3">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.items.map((i) => (
                  <li key={i}><a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{i}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} Aurra AI. {t.footer.rights}</p>
          <p className="text-sm text-muted-foreground">Made with care</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
